import "../../styles/components/ProfileHeader.css";

const ProfileHeader = ({
  title = "Professional Profile",
  subtitle = "Manage your professional information, licences, specialties, certifications, documents and availability.",
}) => {
  return (
    <header className="profile-page-header">
      <div>
        <p className="account-label">
          Professional Portal
        </p>

        <h1>{title}</h1>

        <p className="profile-page-description">
          {subtitle}
        </p>
      </div>
    </header>
  );
};

export default ProfileHeader;